import axios, { AxiosRequestConfig } from 'axios';
import { useCallback } from 'react';
import { APIRequestConfig } from '../api/APIConfigs';
import { Environment } from '../Environment';
import { useRhAuth } from '../contexts/RhAuthContext';

export const useRequest = () => {
  const { isAuthenticated, getAccessTokenSilently } = useRhAuth();
  const {
    services: { logger },
  } = Environment.current();

  const request = useCallback(
    async <T>(config: APIRequestConfig): Promise<T> => {
      const token = await getAccessTokenSilently();

      const formData = new FormData();
      if (config.upload && config.data) {
        const file = config.data as File;
        formData.append('', file, file.name);
      }

      const init: AxiosRequestConfig = {
        url: `${process.env.REACT_APP_API_BASE_URL}${config.url}`,
        method: config.method,
        data: config.upload ? formData : config.data,
        headers: {
          'Content-Type': config.upload ? 'multipart/form-data' : 'application/json',
          Authorization: `Bearer ${isAuthenticated && token ? token : 'anonymous'}`,
          'ngrok-skip-browser-warning': 'true',
        },
      };

      const url0 = '/' + config.url.split('/')[1].split('?')[0];
      logger.log('\n');
      logger.log(`${url0}\t [${init.method}] - ${url0}`);
      logger.log(`${url0}\t [Authorization]:`, init.headers.Authorization);
      logger.log(`${url0}\t [body]:`, init.data);

      return axios(init)
        .then(response => {
          logger.log(`${url0}\t [response]:`, response.data);
          return response.data;
        })
        .catch(function (error) {
          logger.log(`${url0}\t [error.json]:`, error.toJSON());
          if (error.response) {
            logger.log(`${url0}\t [error.response]:`, error.response);
            const errorMessage =
              typeof error.response.data === 'string' ? error.response.data : error.response.data.innerError;
            throw new Error(errorMessage);
          } else if (error.request) {
            logger.log(`${url0}\t [error.request]:`, error.request);
            throw new Error(`Unable to process request (err: ${error.message})`);
          } else {
            logger.log(`${url0}\t [error.message]:`, error.message);
            throw new Error(error.message);
          }
        });
    },
    [getAccessTokenSilently, isAuthenticated, logger]
  );

  return request;
};
